import { Yup } from "@mavichpe/dynamic-forms";
import { TAXES_TYPES } from "@utils/Constants";
import { generateSelectOption } from "@utils/Utils";

const CancelInvoiceFormConfig = {
    submit: {
        label: "Anular Factura"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "razon",
                        "label": "Razon",
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required("El razon de la anulacion es obligatoria")
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "createCreditNote",
                        "label": "Crear Nota de credito para esta anulacion",
                    }
                ],
            ]
        }
    ],
};


export default CancelInvoiceFormConfig;